import { useLocation } from 'react-router-dom'
import {useQuery} from 'react-query'

import {
  api,
  queryClient,
  useMutationQuery,
  replaceQueryClientDataItem,
} from 'base'
import {showSuccessNotification} from 'common/helpers'
import {
  RequestMilestone,
  // REQUEST_STATUS_NAME,
  // REQUEST_MILESTONE_NAME,
  // RequestStatus,
  // RequestTagType,
} from '.'
import { RequestMilestone as VariationRequestMilestone } from './types.variation'

type TagType = 'loan' | 'variation' | 'journal' | 'default' | 'drawdown'

const prefixDict: Record<TagType, string> = {
  'loan'      : 'loanRequest',
  'drawdown'  : 'loanRequest',
  'variation' : 'variationRequest',
  'journal'   : 'journalTransaction',
  'default'   : 'defaultRequest',
}
const reqKeyDict: Record<TagType, string> = {
  'loan'      : 'request',
  'drawdown'  : 'request',
  'variation' : 'variation-request',
  'default'   : 'default-request-details',
  'journal'   : 'journal-request-details',
}

const path2Tag = (pathname:string): TagType => (
  (pathname.indexOf('/requests/loan/')      > -1) ? 'loan' :
  (pathname.indexOf('/requests/variation/') > -1) ? 'variation' :
  (pathname.indexOf('/requests/default/')   > -1) ? 'default' :
  (pathname.indexOf('/requests/journal/')   > -1) ? 'journal' :
  'loan'
)

export const useGetRequest = (uuid: string, enabled?: boolean) =>
  useQuery(
    ['request', uuid],
    async () => {
      const {data} = await api.get(`/loanRequest/${uuid}`, {
        params: {
          include: 'statuses',
        },
      })
      return data.data
    },
    {enabled}
  )

export const useUpdateRequest = (uuid: string, onSuccessActions: () => void) =>
  useMutationQuery(
    ['updateRequest', uuid],
    async (values) => {
      const {data} = await api.post(`/loanRequest/${uuid}`, values)
      return data.data
    },
    {
      onSuccess(newRequest) {
        const requestKey = ['request', uuid]
        queryClient.setQueriesData(requestKey, newRequest)
        queryClient.invalidateQueries(requestKey)
        if (!!newRequest?.project?.uuid) {
          queryClient.invalidateQueries(['forecast', newRequest.project.uuid])
        } else {
          console.error('new request response error')
        }
        onSuccessActions()
        showSuccessNotification('Request loan info has been updated.')
      },
    }
  )

export const usePassRequestMilestone = (
  requestUuid: string,
  milestoneType: RequestMilestone | VariationRequestMilestone,
  onSuccessActions?: () => void
) => {
  const {pathname} = useLocation()
  return useMutationQuery<any, any>(
    ['passRequestMilestone', requestUuid, milestoneType, pathname],
    async (values: any) => {
      const url = `/${prefixDict[path2Tag(pathname)]}/${requestUuid}/milestone/pass`
      // console.log(pathname, path2Tag(pathname))
      // console.log(pathname, requestUuid, url)
      const {data} = await api.post(
        url,
        {
          ...values,
          type: milestoneType,
        }
      )
      return data.data
    },
    {
      onSuccess(newRequest) {
        const requestKey = [reqKeyDict[path2Tag(pathname)], requestUuid]
        queryClient.setQueriesData(requestKey, (oldRequest: any) => ({
          ...newRequest,
          project: oldRequest.project,
        }))
        queryClient.invalidateQueries(requestKey)
        onSuccessActions && onSuccessActions()
        showSuccessNotification(
          `Milestone pass success.`
          // `${REQUEST_MILESTONE_NAME[milestoneType]} success.`
        )
      },
    }
  )
}
/*
export const useExPassRequestMilestone = (
  requestUuid: string,
  milestoneType: RequestMilestone,
  tag: RequestTagType,
  onSuccessActions?: () => void,
) => {
  return useMutationQuery<any, any>(
    ['passRequestMilestone', requestUuid, milestoneType, tag],
    async (values: any) => {
      const {data} = await api.post(
        `/${prefixDict[tag]}/${requestUuid}/milestone/pass`,
        {
          ...values,
          type: milestoneType,
        }
      )
      return data.data
    },
    {
      onSuccess(newRequest) {
        const requestKey = [reqKeyDict[tag], requestUuid]
        queryClient.setQueriesData(requestKey, (oldRequest: any) => ({
          ...newRequest,
          project: oldRequest.project,
        }))
        queryClient.invalidateQueries(requestKey)
        onSuccessActions && onSuccessActions()
        showSuccessNotification(
          `Milestone pass success.`
        )
      },
    }
  )
}
*/
export const useAcceptRequestStatus = (
  requestUuid: string,
  onSuccessActions?: () => void
) => {
  const {pathname} = useLocation()
  return useMutationQuery(
    ['acceptRequestStatus', requestUuid, pathname],
    async () => {
      const {data} = await api.post(
        `/${prefixDict[path2Tag(pathname)]}/${requestUuid}/status/next/accept`
      )
      return data.data
    },
    {
      onSuccess(newRequest) {
        const requestKey = [reqKeyDict[path2Tag(pathname)], requestUuid]
        queryClient.setQueriesData(requestKey, newRequest)
        queryClient.invalidateQueries(requestKey)
        queryClient.invalidateQueries('requests')
        onSuccessActions && onSuccessActions()
        showSuccessNotification(
          `Request status updated.`
          // `Request status updated to "${
          //   REQUEST_STATUS_NAME[newRequest.status as RequestStatus]
          // }".`
        )
      },
    }
  )
}
/*
export const useExAcceptRequestStatus = (
  requestUuid: string,
  tag?: RequestTagType,
  onSuccessActions?: () => void,
) => {
  return useMutationQuery(
    ['acceptRequestStatus', requestUuid, tag],
    async () => {
      const {data} = await api.post(
        `/${prefixDict[tag]}/${requestUuid}/status/next/accept`
      )
      return data.data
    },
    {
      onSuccess(newRequest) {
        const requestKey = [reqKeyDict[tag], requestUuid]
        queryClient.setQueriesData(requestKey, newRequest)
        queryClient.invalidateQueries(requestKey)
        queryClient.invalidateQueries('requests')
        onSuccessActions && onSuccessActions()
        showSuccessNotification(
          `Request status updated.`
        )
      },
    }
  )
}
*/
export const useDeclineRequest = (
  requestUuid: string,
  onSuccessActions?: () => void
) => {
  const {pathname} = useLocation()
  return useMutationQuery<any, any>(
    ['declineRequest', requestUuid, pathname],
    async (values: any) => {
      const {data} = await api.post(
        `/${prefixDict[path2Tag(pathname)]}/${requestUuid}/status/next/reject`,
        values
      )
      return data.data
    },
    {
      onSuccess(newRequest) {
        const requestKey = [reqKeyDict[path2Tag(pathname)], requestUuid]
        queryClient.setQueriesData(requestKey, newRequest)
        queryClient.invalidateQueries(requestKey)
        onSuccessActions && onSuccessActions()
        showSuccessNotification(
          'Request delined.'
          // `Request status updated to "${
          //   REQUEST_STATUS_NAME[newRequest.status as RequestStatus]
          // }".`
        )
      },
    }
  )
}

/*
export const useExDeclineRequest = (
  requestUuid: string,
  onSuccessActions?: () => void,
  tag?: RequestTagType,
) => {
  return useMutationQuery<any, any>(
    ['declineRequest', requestUuid, tag],
    async (values: any) => {
      const {data} = await api.post(
        `/${prefixDict[tag]}/${requestUuid}/status/next/reject`,
        values
      )
      return data.data
    },
    {
      onSuccess(newRequest) {
        const requestKey = [reqKeyDict[tag], requestUuid]
        queryClient.setQueriesData(requestKey, newRequest)
        queryClient.invalidateQueries(requestKey)
        onSuccessActions && onSuccessActions()
        showSuccessNotification(
          `Request declined.`
        )
      },
    }
  )
}
*/
export const useAssignManager = (
  projectUuid: string,
  onSuccessActions?: () => void
) =>
  useMutationQuery(
    ['assignManager', projectUuid],
    async (values) => {
      const {data} = await api.post(
        `/project/${projectUuid}/manager/assign`,
        values
      )
      return data
    },
    {
      onSuccess() {
        queryClient.invalidateQueries('request')
        queryClient.invalidateQueries('project')
        queryClient.invalidateQueries('requests')
        onSuccessActions && onSuccessActions()
      },
    }
  )

export const useAssignBorrower = (
  projectUuid: string,
  onSuccessActions?: () => void
) =>
  useMutationQuery(
    ['assignBorrower', projectUuid],
    async (values) => {
      const {data} = await api.post(
        `/project/${projectUuid}/borrower/assign`,
        values
      )
      return data
    },
    {
      onSuccess() {
        queryClient.invalidateQueries('request')
        queryClient.invalidateQueries('variation-request')
        queryClient.invalidateQueries('project')
        onSuccessActions && onSuccessActions()
      },
    }
  )

export const useAssignBroker = (
  projectUuid: string,
  onSuccessActions?: () => void
) =>
  useMutationQuery(
    ['assignBroker', projectUuid],
    async (values) => {
      const {data} = await api.post(
        `/project/${projectUuid}/broker/assign`,
        values
      )
      return data
    },
    {
      onSuccess() {
        queryClient.invalidateQueries('request')
        queryClient.invalidateQueries('variation-request')
        queryClient.invalidateQueries('project')
        onSuccessActions && onSuccessActions()
      },
    }
  )

export const useGetAML = (projectUuid: string, enabled?: boolean) =>
  useQuery(
    ['aml', projectUuid],
    async () => {
      const {data} = await api.get('/amlCheck/list', {
        params: {
          project: projectUuid,
          include: 'media',
        },
      })
      return data.data
    },
    {enabled}
  )

export const useAddAMLBeneficiary = (
  projectUuid: string,
  onSuccessActions?: () => void
) =>
  useMutationQuery<any, any, any>(
    ['addAMLBeneficiary', projectUuid],
    async (values) => {
      const {data} = await api.post(`/amlCheck/new`, {
        project: projectUuid,
        ...values,
      })
      return data.data
    },
    {
      onSuccess() {
        queryClient.invalidateQueries('aml')
        onSuccessActions && onSuccessActions()
        showSuccessNotification('AML beneficiary has beed added.')
      },
    }
  )

export const useUpdateAMLBeneficiary = (
  amlUuid: string,
  projectUuid: string,
  onSuccessActions?: () => void
) =>
  useMutationQuery<any, any, any>(
    ['updateAMLBeneficiary', amlUuid],
    async (values) => {
      const {data} = await api.post(`/amlCheck/${amlUuid}`, values)
      return data.data
    },
    {
      onSuccess(newAml) {
        const requestKey = ['aml', projectUuid]
        replaceQueryClientDataItem(requestKey, newAml)
        queryClient.invalidateQueries(requestKey)
        onSuccessActions && onSuccessActions()
        showSuccessNotification('AML beneficiary has beed updated.')
      },
    }
  )

export const useResendAMLLink = (amlUuid: string) =>
  useMutationQuery<any, any, any>(
    ['resendAMLLink', amlUuid],
    async () => {
      const {data} = await api.post(`/amlCheck/${amlUuid}/sms/resend`)
      return data.data
    },
    {
      onSuccess() {
        queryClient.invalidateQueries('aml')
        showSuccessNotification('The link has been sent.')
      },
    }
  )

export const useApproveAML = (amlUuid: string, onSuccessActions?: () => void) =>
  useMutationQuery(
    ['approveAML', amlUuid],
    async () => {
      const {data} = await api.post(`/amlCheck/${amlUuid}/approve`)
      return data.data
    },
    {
      onSuccess() {
        queryClient.invalidateQueries('aml')
        onSuccessActions && onSuccessActions()
        showSuccessNotification('The AML has been approved.')
      },
    }
  )

export const useRejectAML = (amlUuid: string, onSuccessActions?: () => void) =>
  useMutationQuery(
    ['rejectAML', amlUuid],
    async (values) => {
      const {data} = await api.post(`/amlCheck/${amlUuid}/reject`, values)
      return data.data
    },
    {
      onSuccess() {
        queryClient.invalidateQueries('aml')
        queryClient.invalidateQueries('request')
        onSuccessActions && onSuccessActions()
        showSuccessNotification('The AML has been rejected.')
      },
    }
  )

export const useGetRequestLineFeeSchedule = (
  requestUuid: string,
  enabled: boolean = false,
  onSuccessActions?: (lineFeeSchedule: any) => void
) =>
  useQuery<any>(
    ['requestLineFeeSchedule', requestUuid],
    async () => {
      const {data} = await api.get(
        `/loanRequest/${requestUuid}/schedule/lineFee`
      )
      return data.data
    },
    {
      enabled,
      onSuccess(lineFeeSchedule) {
        onSuccessActions(lineFeeSchedule)
      },
    }
  )
